/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Vollfreigestelltpflege3Inputs */



/**

* @param {_Class_Vollfreigestelltpflege3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_vollfreigestelltpflege3 = /** @type {((inputs?: _Class_Vollfreigestelltpflege3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Vollfreigestelltpflege3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Pflegezeit mit vollständiger Freistellung")
});
export { _class_vollfreigestelltpflege3 as "_class_VollFreigestelltPflege" }